/**
 * Resolve the signed-in user's payroll PIN.
 * Redux `usersList.users` is the full users array (not the current user),
 * so callers must not read `users.pinNumber` directly.
 */
export function getCurrentUserPin(users, authUser) {
  if (authUser?.pinNumber != null && authUser.pinNumber !== "") {
    return String(authUser.pinNumber);
  }

  if (Array.isArray(users)) {
    const identityId = authUser?.identityId;
    const email = (authUser?.email || "").toLowerCase();
    const match =
      users.find((u) => identityId && u?.identityId === identityId) ||
      users.find((u) => email && (u?.email || "").toLowerCase() === email);
    if (match?.pinNumber != null && match.pinNumber !== "") {
      return String(match.pinNumber);
    }
    return null;
  }

  if (users?.pinNumber != null && users.pinNumber !== "") {
    return String(users.pinNumber);
  }

  return null;
}

export const PAGAT_PIN_SESSION_KEY = "pagatPinUnlocked";

export function isPagatPinUnlocked() {
  try {
    return sessionStorage.getItem(PAGAT_PIN_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function setPagatPinUnlocked(unlocked = true) {
  try {
    if (unlocked) sessionStorage.setItem(PAGAT_PIN_SESSION_KEY, "1");
    else sessionStorage.removeItem(PAGAT_PIN_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
